<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="订单号">
              <a-input placeholder="请输入订单号模糊查询" v-model="queryParam.docCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="手工合同号">
              <a-input placeholder="请输入手工合同号模糊查询" v-model="queryParam.predoccode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称模糊查询" v-model="queryParam.project"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a :href="downloadAllHref" :download="downloadAllHref">
        <a-button  v-show="selectedRowKeys.length>0"   type="primary" icon="plus">批量下载</a-button>
      </a>
      <div v-show="selectedRowKeys.length==0" class="mini-heigh" ></div>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="docCode"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a  @click="handleSeeMoreClick(record)"  >查看</a>
          <a-divider type="vertical" />
          <a :href="ftpDownloadUrl+`/filecopy/ftpFile/download?docCode=${record.docCode}&ip=${record.path1}`" :download="ftpDownloadUrl+`/filecopy/ftpFile/download?docCode=${record.docCode}&ip=${record.path1}`">下载</a>
        </span>
      </a-table>
    </div>
    <ftp-file-detail-table  ref="ftpFileDetailTableRef"  ></ftp-file-detail-table>
    <ftpFileInfo-modal ref="modalForm" @ok="modalFormOk"></ftpFileInfo-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import FtpFileInfoModal from './modules/FtpFileInfoModal'
  import { downFile } from '@/api/manage'
  import FtpFileDetailTable from "./modules/FtpFileDetailTable.vue"

  export default {
    name: "FtpFileInfoList",
    mixins:[JeecgListMixin],
    components: {
      FtpFileInfoModal,FtpFileDetailTable
    },
    data () {
      return {
        description: '文件下载管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'订单号',
            align:"center",
            dataIndex: 'docCode'
          },
          {
            title:'文件路径',
            align:"center",
            dataIndex: 'path1'
          },
          {
            title:'手工合同号',
            align:"center",
            dataIndex: 'predoccode'
          },
          {
            title:'项目名称',
            align:"center",
            dataIndex: 'project'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/base/ftpFileInfo/list",
          delete: "/base/ftpFileInfo/delete",
          deleteBatch: "/base/ftpFileInfo/deleteBatch",
          exportXlsUrl: "/base/ftpFileInfo/exportXls",
          importExcelUrl: "base/ftpFileInfo/importExcel",
        },
        dictOptions:{},
        ftpDownloadUrl:process.env.VUE_APP_FTPDownloadUrl,
        downloadAllHref:"",
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      // 发起下载
      downloadFtpFile(data){
        let parms = {
          docCode: data.docCode,
          ip: data.path1,
        }
        // let urltemp=`${process.env.VUE_APP_domianURL}/base/ftpFileInfo/downloadFtpFile?docCode=${data.docCode}&path1=${data.path1}`
        // // window.open(urltemp)
        // let a = document.createElement('a')
        // a.href =urltemp
        // a.click();
        // return
        //使用jeecg封装好的下载js下载xls
        let urlTemp=process.env.VUE_APP_FTPDownloadUrl+`/filecopy/ftpFile/download?docCode=${parms.docCode}&ip=${parms.ip}`
        window.open(urlTemp, "_blank");
        return
        downFile('', parms).then((res) => {
          console.log(res)
          if (!res) {
            this.$message.warning('文件下载失败')
            this.exproting = false
            return
          }

          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([res], { type: "application/zip" }), data.docCode)
            this.exproting = false
            this.$message.success('下载成功！')
            this.showExprotSetting = false
          } else {
            let url = window.URL.createObjectURL(new Blob([res], { type: "application/zip" }))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', data.docCode)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link) //下载完成移除元素
            window.URL.revokeObjectURL(url) //释放掉blob对象
            this.exproting = false
            this.$message.success('下载成功！')
            this.showExprotSetting = false
          }
        })
      },
      downloadFtpFileAll(){
        let pathParams=this.selectionRows.reduce((total,value,index)=>{
              if(index==1){
                return total.docCode+"+"+total.path1+","+value.docCode+"+"+value.path1
              }else{
                return total+","+value.docCode+"+"+value.path1
              }
            })
        let urlTemp=process.env.VUE_APP_FTPDownloadUrl+`/filecopy/ftpFile/downloadBatch?docCodeList=${pathParams}`
        this.downloadAllHref=urlTemp;
      },
      handleSeeMoreClick(record){
        this.$refs.ftpFileDetailTableRef.open(record.docCode) 
      }
    },
    watch:{
      selectionRows(){
        this.downloadFtpFileAll()
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .mini-heigh{
    min-height: 32px;
    margin-top: 8px;
  }
</style>